import { render } from "./AnswerBankTalent.vue?vue&type=template&id=669c2b56&scoped=true"
import script from "./AnswerBankTalent.vue?vue&type=script&lang=js"
export * from "./AnswerBankTalent.vue?vue&type=script&lang=js"

import "./AnswerBankTalent.vue?vue&type=style&index=0&id=669c2b56&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src3389461850/src/acx.portal/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-669c2b56"]])

export default __exports__